import React from "react";
import { Dialog, Box, useMediaQuery, useTheme } from "@mui/material";
import Authentication from "./Authentication";

const AuthenticationModal = ({
  isOpen,
  closeModal,
  customScope = "",
  section = "login",
  singleJob = true,
  addApplyLogin = false,
  addResumeLogin = false,
  addFavoriteLogin = false,
  isSpontaneous = false,
}) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Dialog
      open={isOpen}
      onClose={closeModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        "& .MuiDialog-container": {
          "& .MuiDialog-paper": {
            margin: "16px !important",
            borderRadius: "1rem",
            bgcolor: "hsl(0 0% 100%)",
            backgroundImage: "none",
            maxWidth: "450px",
            width: "100%",
          },
        },
      }}
    >
      <Box
        sx={{
          justifyContent: "center",
          maxWidth: "450px",
          borderRadius: "1rem",
          p: isDesktop ? "36px" : "32px",
        }}
      >
        <Box sx={{ height: "min-content" }}>
          <Authentication
            onActionFinished={closeModal}
            customScope={customScope}
            section={section}
            singleJob={singleJob}
            addApplyLogin={addApplyLogin}
            addResumeLogin={addResumeLogin}
            addFavoriteLogin={addFavoriteLogin}
            isSpontaneous={isSpontaneous}
          />
        </Box>
      </Box>
    </Dialog>
  );
};

export default AuthenticationModal;
